import styled from 'styled-components';
import WarningMessage from '../WarningMessage';

type InputAreaStyleType = {
  isDisabled?: boolean;
  hasError?: boolean;
};

const getColor = (regularColor: string, isDisabled?: boolean, hasError?: boolean): string => {
  if (isDisabled) {
    return '#E2E8F0';
  }

  if (hasError) {
    return '#fc8181';
  }

  return regularColor;
};

export const InputBox = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  &:not(:last-of-type) {
    margin-bottom: 16px;
  }
  * {
    font-size: 12px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    text-align: left;
  }
`;

export const InputArea = styled.div<InputAreaStyleType>`
  span.chakra-checkbox__control {
    border: 1px solid
      ${(props) => getColor(props.theme.colors['neutral-90'], props.isDisabled, props.hasError)};
    border-radius: 2px;
    width: 16px;
    height: 16px;
  }

  svg {
    font-size: 6px;
  }
`;

export const CustomWarningMessage = styled(WarningMessage)`
  position: inherit;
  margin-left: 12px;
`;
